module.exports = __webpack_public_path__ + "static/media/galeryCurtains4.8e39e12e.jpg";